class FaqAccordion extends HTMLElement {
  constructor() {
    super();
    this.items = [];
    this.handleToggle = (event) => this.onToggle(event);
  }

  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.faq-item'));
    this.items.forEach((item) => item.addEventListener('toggle', this.handleToggle));
  }

  disconnectedCallback() {
    this.items.forEach((item) => item.removeEventListener('toggle', this.handleToggle));
  }

  onToggle(event) {
    const target = event.target;
    this.setExpanded(target, target.open);

    if (!target.open) return;

    // Only one FAQ item stays open at a time within this component instance.
    this.items.forEach((item) => {
      if (item === target) return;
      item.removeAttribute('open');
      this.setExpanded(item, false);
    });
  }

  setExpanded(item, isExpanded) {
    item.querySelector('summary')?.setAttribute('aria-expanded', isExpanded);
  }
}

if (!customElements.get('faq-accordion')) {
  customElements.define('faq-accordion', FaqAccordion);
}
